import { Form, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'

import { HelperWrapper, MediaInput } from 'src/components'
import { ETranslationNs, ICreateMediaForm } from 'src/types'

import { useStyles } from './styles'

export const MediaCreateForm = () => {
  const [t] = useTranslation(ETranslationNs.Form)
  const classes = useStyles()
  const { values, setFieldValue, errors, isSubmitting, dirty } =
    useFormikContext<ICreateMediaForm>()

  return (
    <Form className={classes.form}>
      <MediaInput
        disabledBorder
        errorText={errors.media as string}
        setFieldValue={setFieldValue}
        media={values.media}
        title={t('media-input-title.v') + '*'}
        noJourneyOptions
      />
      <div className={classes.submitWrapper}>
        <Button
          type="submit"
          variant="contained"
          disabled={isSubmitting || Object.keys(errors).length > 0 || !dirty}
        >
          <HelperWrapper t="create-button-text" />
        </Button>
      </div>
    </Form>
  )
}
